<template>
  <div>
    <b-card>
      <title-text />
      <content-text />
      <ordering-number />
    </b-card>
    <b-button
      variant="primary"
      :disabled="itemData.submitStatus"
      @click="submitForm"
    >
      Kaydet
    </b-button>
  </div>
</template>

<script>
import {
  BCard, BButton,
} from 'bootstrap-vue'

import { required } from '@validations'

import TitleText from '@/views/Admin/Contents/elements/TitleText.vue'
import ContentText from '@/views/Admin/Contents/elements/ContentText.vue'
import OrderingNumber from '@/views/Admin/Contents/elements/OrderingNumber.vue'

export default {
  name: 'ItemForm',
  components: {
    BCard,
    BButton,
    TitleText,
    ContentText,
    OrderingNumber,
  },
  props: {
    submitForm: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    itemData() {
      return this.$store.getters['contents/dataItem']
    },
  },
  mounted() {
    this.itemData.submitStatus = false
  },
}
</script>
